// components/Footer.tsx
import React from 'react';
import { X, Linkedin } from 'lucide-react';

const Footer = () => {
    const currentYear = new Date().getFullYear();
  return (
    <div className="mt-20 pt-12 border-t border-white/10 text-white">
      <div className="flex flex-col items-center justify-center gap-4">
        {/* Social Icons */}
        <div className="flex gap-6">
          <a
            href="https://x.com/UTRtherapeutics"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-sky-400 transition-colors duration-300"
            aria-label="UTR Twitter"
          >
            <X className="w-6 h-6" />
          </a>
          <a
            href="https://linkedin.com/company/utrtherapeutics"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-blue-500 transition-colors duration-300"
            aria-label="UTR LinkedIn"
          >
            <Linkedin className="w-6 h-6" />
          </a>
        </div>

        {/* Copyright */}
        <p className="text-sm text-blue-100">
          &copy; {currentYear} UTR Therapeutics Inc. All Rights Reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
